import type { MockedResponse } from "@apollo/client/testing";

export function withTypenames<T>(node: T, typename: string) {
  return { __typename: typename, ...node };
}

export function createCatalogMock(
  query: MockedResponse["request"]["query"],
  data: Record<string, unknown>
): MockedResponse {
  return {
    request: { query },
    maxUsageCount: Infinity,
    variableMatcher: () => true,
    result: { data }
  };
}

export type MockResolver = (variables: Record<string, unknown>) => Record<string, unknown>;
